'use strict';

angular.module('shiftTraderApp')
    .directive('saMiniDayViewShift', function (PositioningService, TimeService, UtilityService) {
      return {
        templateUrl: 'views/directives/saMiniDayViewShift.html',
        restrict: 'A',
        replace: true,
        require: '^saMiniDayView',
        scope: {
          obj: '=saMiniDayViewShift'
        },
        link: function postLink(scope, element, attrs, ctrl) {
          var currentDate = ctrl.getCurrentDate();
          var hourOffsetFromLeft = 0.0;
          var hourExtensionToRight = 6.0;
          var newClasses;
          scope.wpClasses = {};

          element.attr('id', 'sa-mini-day-view-' + scope.obj._type + '-' + scope.obj.id);

          scope.isAssigned = scope.obj.$isAssigned() || (scope.obj.$isShift() && scope.obj._workPeriod && scope.obj._workPeriod.$isAssigned());
          scope.isShift = scope.obj.$isShift() && !scope.obj._workPeriod;


          var updateProperties = function(newDate) {
            currentDate = newDate;
            var currentObj = ctrl.getCurrentObj();

            if (scope.obj.$isWorkPeriod()) {
              scope.obj._shortLocalStartTime = scope.obj.start_time.format('h:mm');
              scope.obj._shortLocalEndTime = scope.obj.end_time.format('h:mm');
              scope.inThePast = scope.obj.start_time.isBefore(scope.nowTime);
              scope.obj._shiftCost = scope.obj.range_twix.length('minutes') / 60.0 * scope.obj.hourly_wage;
            } else {
              //scope.obj.$setDateForTimeCalcs(currentDate);
              scope.obj._shortLocalStartTime = TimeService.minutesToTimeString(scope.obj.start_minutes);
              scope.obj._shortLocalEndTime = TimeService.minutesToTimeString(scope.obj.end_minutes);
            }

            var viewWindow = moment(currentDate).subtract(hourOffsetFromLeft, 'hours').twix(moment(currentDate).add(24 + hourExtensionToRight, 'hours'));
            var positioningResults = PositioningService.calcLeftAndWidthInRatios(scope.obj.range_twix, viewWindow);

            scope.useInitials = positioningResults.diffInHours <= 1.75 ||
                (positioningResults.diffInHours < 3 && positioningResults.diffInHours > 2);

            if (scope.isAssigned) {
              if (scope.obj.$isWorkPeriod()) {
                if (scope.useInitials) {
                  scope.displayName = scope.obj.user.first_name[0] + scope.obj.user.last_name[0];
                } else {
                  scope.displayName = scope.obj.user.first_name + ' ' + scope.obj.user.last_name[0];
                }
              } else {
                if (scope.useInitials) {
                  scope.displayName = scope.obj._workPeriod.user.first_name[0] + scope.obj._workPeriod.user.last_name[0];
                } else {
                  scope.displayName = scope.obj._workPeriod.user.first_name + ' ' + scope.obj._workPeriod.user.last_name[0];
                }
              }
            } else {
              scope.displayName = '';
            }


            newClasses = {
              work_period: !scope.isShift,
              shift: scope.isShift,
              shift_animate_bg: currentObj && currentObj._type === scope.obj._type && currentObj.id === scope.obj.id,
              published: scope.obj.$isPublished(),
              unpublished: !scope.obj.$isPublished(),
              assigned: scope.isAssigned,
              unassigned: !scope.isAssigned,
              selected: currentObj && currentObj._type === scope.obj._type && currentObj.id === scope.obj.id,
              dismissed: scope.obj._dismissed
            };

            var classOperations = UtilityService.calcClassDiff(scope.wpClasses, newClasses);
            scope.wpClasses = newClasses;

            element.removeClass(classOperations.remove);
            element.addClass(classOperations.add);

            //z-index trick is pretty neat here...
            //  In order for the dropdown menu to be on top of the next ship we must decrement
            //    the z-index for every wp/shift on the page
            //  scope.$index is the current index of the loop over wp/shifts in a position
            //  scope.$parent.$index is the current index of the loop over positions
            //  Max allows for 20 wp/shifts per position and up to 20? positions before we go behind the hour/half-hour lines

            scope.workPeriodStyle = {
              width: positioningResults.styles.width * 100 + '%',
              left: positioningResults.styles.left * 100 + '%',
             // 'z-index': 980 - scope.obj._miniTop/saViewShiftRowHeightInt - scope.$parent.$parent.$index * 20,
              top: scope.obj._miniTop + 'px'
            };

            element.css(scope.workPeriodStyle);
          };

          updateProperties(ctrl.getCurrentDate());

          scope.selectShift = function() {
            console.log('selectShift', scope.obj.id);
            ctrl.selectShiftOrWorkPeriod(scope.obj._type, scope.obj.id);
          };

          scope.$on('saMiniDayView:update', function(event, data) {
            event.stopPropagation();
            console.log('EVENT SEEN: saMiniDayView:update');
            reInitAssignedProps();
            updateProperties(currentDate);
          });

          var miniTopWatchDereg = scope.$watch('obj._miniTop', function(newVal, oldVal) {
            if (!_.isUndefined(newVal)) {
              updateProperties(ctrl.getCurrentDate());
              miniTopWatchDereg();
            }
          });

          scope.$watch('obj._compId', function(newVal, oldVal) {
            if (!_.isUndefined(newVal) && newVal !== oldVal) {
              reInitAssignedProps();
              updateProperties(ctrl.getCurrentDate());
            }
          });

          function reInitAssignedProps() {
            scope.isAssigned = scope.obj.$isAssigned() || (scope.obj.$isShift() && scope.obj._workPeriod && scope.obj._workPeriod.$isAssigned());
            scope.isShift = scope.obj.$isShift() && !scope.obj._workPeriod;
          }

        }
      };
    });
